/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import useCollectiveitems from '../../hooks/useCollectiveitems';

const CollectiveitemsList = (props: any) => {
  const { isRTL, height } = props;

  const { collectiveitems } = useCollectiveitems();
  return (
    <Paper
      elevation={2}
      style={{
        height,
        width: '100%',
        overflow: 'auto',
      }}
    >
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box
            style={{
              display: 'flex',
              height: 50,
              alignItems: 'center',
              paddingLeft: 15,
              paddingRight: 15,
            }}
          >
            <Typography style={{ fontWeight: 'bold', fontSize: 18 }}>
              الباكجات المتوفرة
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={9}>
          <Box p={2}>
            <Grid container spacing={2}>
              {collectiveitems?.map((item: any) => (
                <Grid item xs={3}>
                  <Card style={{ backgroundColor: '#fafafa' }}>
                    <CardHeader
                      title={isRTL ? item.name : item.nameAr}
                    ></CardHeader>
                    <CardContent>
                      {/* <Box>{item.subitems}</Box> */}
                      <Box>{item.price}</Box>
                    </CardContent>
                    <CardActions></CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={3}>
          Calendar
        </Grid>
      </Grid>
    </Paper>
  );
};
export default CollectiveitemsList;
